module.exports = __webpack_public_path__ + "img/shire.059e4ecb.jpg";